import mutations from '@/dashboard/store/mutations'

export default {
	updateDateRange : mutations.updateDateRange,

	/**
	 * Sets the leads data for the page based on our initial API Request
	 * @param {Object} state the application state.
	 * @param {Object} payload the API response body
	 *
	 * @returns {void}
	 */
	setLeadsPageData (state, payload) {
		state.filterOptions.campaigns = payload.campaigns
		state.filterOptions.tags      = payload.tags
		state.leads                   = payload.leads
		state.page                    = parseInt(payload.pagination.currentPage)
		state.count                   = parseInt(payload.pagination.count)
	},

	removeLead (state, leadId) {
		const index = state.leads.findIndex(lead => leadId === lead.id)
		state.leads.splice(index, 1)
	},

	resetLeads (state) {
		state.leads = []
	},

	/**
	 * Sets the leads campaign data for the page based on our initial API Request
	 * @param {Object} state the application state.
	 * @param {Object} payload the API response body
	 *
	 * @returns {void}
	 */
	setLeadCampaignPageData (state, payload) {
		state.campaigns = payload.campaigns
		state.page      = parseInt(payload.pagination.currentPage)
		state.count     = parseInt(payload.pagination.count)
	},

	/**
	 * Sets the leads tag data for the page based on our initial API Request
	 * @param {Object} state the application state.
	 * @param {Object} payload the API response body
	 *
	 * @returns {void}
	 */
	setLeadTagPageData (state, payload) {
		state.tags  = payload.tags
		state.page  = parseInt(payload.pagination.currentPage)
		state.count = parseInt(payload.pagination.count)
	},

	setLeadStats (state, payload) {
		state.stats.period.start = payload.period.start
		state.stats.period.end   = payload.period.end
		state.stats.dates        = payload.dates
		state.stats.change       = payload.percent_change
		state.stats.current      = payload.current_period
		state.stats.prior        = payload.prior_period
	},

	resetLeadCampaigns (state) {
		state.campaigns.splice(0)
	},

	page (state, payload) {
		const page = parseInt(payload, 10)
		if (!Number.isNaN(page)) {
			state.page = page
		}
	},

	updateCampaignFilter (state, payload) {
		state.filters.campaign = payload
	},

	updateTagFilter (state, payload) {
		state.filters.tag = payload
	},

	addToBulk (state, leadId) {
		this._vm.$set(state.bulk, state.bulk.length, leadId)

		if (state.bulk.length === state.leads.length) {
			this._vm.$set(state, 'isSelectAll', true)
		}
	},
	removeFromBulk (state, leadId) {
		const index = state.bulk.indexOf(leadId)
		if (-1 !== index) {
			this._vm.$delete(state.bulk, index)
			this._vm.$set(state, 'isSelectAll', false)
		}
	},

	setSearch (state, payload) {
		state.search = payload
	},

	setExportCount (state, payload) {
		state.exportCount = payload
	},

}
